/**
 * Origem Flow: fluxo de criação por teclado. Quando o usuário sai do título
 * (Tab no "ghost input" ou num editor aberto), a próxima célula selecionada
 * deve nascer já em edição — dropdown aberto, calendário na tela — para as
 * setas e o Enter funcionarem sem um Enter extra.
 *
 * A célula ativa só monta DEPOIS da seleção (mesmo problema do clique no
 * campo de data), então o pedido é um flag global com validade curta que o
 * mounted da célula consome.
 */

let requestedAt = 0

export function requestAutoEdit() {
  requestedAt = Date.now()
}

export function consumeAutoEdit() {
  const recent = Date.now() - requestedAt < 800
  requestedAt = 0
  return recent
}
